module.exports = __webpack_public_path__ + "static/media/KFC23-BANNER-PORTRAIT-LIGHT-min.ffd113fa.jpg";